import React, { useEffect, useState } from 'react'
import './Navbar.scss'
import { Link, Outlet } from 'react-router-dom'
import logoimox from '../../../assets/images/logo-imox.png'
import dashboardIcon from '../../../assets/images/Dashboard Icon.svg'
import menuIcon from '../../../assets/images/menu-icon.svg'
import { useLocation } from 'react-router-dom'
import Dashboard from '../../Home/Dashboard'
import { useNavigate } from 'react-router-dom'
import { logout } from '../../../service/apiService'
import { useDispatch, useSelector } from 'react-redux';
import { adminlog } from '../../../features/auth'
import Loader from '../../common/loader/Loader'
const Navbar = () => {
  const [menuActive, setMenuActive] = useState(true);
  const [hamburgerActive, setHamburgerActive] = useState(false);
  const sidebarActivate = (event) => {
    event.preventDefault();
    setMenuActive(!menuActive);
    setHamburgerActive(!hamburgerActive);
  };
  const loactions = useLocation()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const {spinner} = useSelector((state)=>state.spin) 
  const logOut = async () => {
    await logout()
    dispatch(adminlog(false))
    localStorage.removeItem('token')
    await navigate('/', {replace:true})
  }
  return (
    <div>
         <main id="main" class="pushmenu-push" className={`pushmenu-push ${hamburgerActive ? 'menuactive' : ''}`} >
            <div class="wrapper">
                <div class="user-dashboard" id="sidebar">
                    <div class="user-dashboard-left">
                        <div class="d-flex align-items-center logo-menu py-0">
                          <div class="nav-logo">
                            <a href="login.html" class="brand-logo">
                                <img class="logo-abbr" src={logoimox} alt="failed" />
                                <span class="short-logo">
                                   <img src={logoimox} alt="failed" />
                                </span>
                            </a>
                        </div>
                        </div>
                    
                        <ul class="sidemenu" className={`pushmenu-push sidemenu ${menuActive ? 'menuactive' : ''}`}>
                            <li className={`${loactions.pathname === "/home" ? 'active' : '' }`} >
                                <Link to="/home" onClick={() => setHamburgerActive(!hamburgerActive)}>
                                    <img src={dashboardIcon}/>
                                    <span class="nav-text">Dashboard</span>
                                </Link>
                            </li>
                            <li className={`${loactions.pathname === "/home/products"  ? 'active' : '' }`} >
                                <Link to="/home/products" onClick={() => setHamburgerActive(!hamburgerActive)}>
                                    <img src='/images/Manage%20Trainees%20Icon.svg' alt='failed' />
                                    <span class="nav-text">Products</span>
                                </Link>
                            </li>
                            <li className={`${loactions.pathname === "/home/orders" ? 'active' : '' }`}>
                            <Link to="/home/orders" onClick={() => setHamburgerActive(!hamburgerActive)}>
                                    <img src="/images/Manage%20PTs.svg"/>
                                    <span class="nav-text">Orders</span>
                                </Link>
                            </li>
                            <li className={`${loactions.pathname === "/home/masters" ? 'active' : '' }`} >
                                <Link to="/home/masters" onClick={() => setHamburgerActive(!hamburgerActive)}>
                                    <img src="/images/Settings.svg"/>
                                    <span class="nav-text">Master </span>
                                </Link>
                            </li>

                            <li className={`${loactions.pathname === "/home/cms" ? 'active' : '' }`}>
                            <Link to="/home/cms" onClick={() => setHamburgerActive(!hamburgerActive)}>
                            <img src="/images/Bookings%20icon.svg"/>
                            <span class="nav-text">CMS</span>
                                </Link>
                            </li>
   
                            <li className={`${loactions.pathname === "/home/users" ? 'active' : '' }`}>
                            <Link to="/home/users" onClick={() => setHamburgerActive(!hamburgerActive)}>
                            <img src="/images/Bookings%20icon.svg"/>
                            <span class="nav-text">Users</span>
                                </Link>
                            </li>
                            <li> 
                            <li className={`${loactions.pathname === "/home/userhome" ? 'active' : '' }`}>
                            <Link to="/home/userhome" onClick={() => setHamburgerActive(!hamburgerActive)}>
                            <img src="/images/Bookings%20icon.svg"/>
                            <span class="nav-text">Home</span>
                                </Link>
                            </li>
                            <li className={`${loactions.pathname === "/home/backup" ? 'active' : '' }`}>
                            <Link to="/home/backup" onClick={() => setHamburgerActive(!hamburgerActive)}>
                            <img src="/images/Bookings%20icon.svg"/>
                            <span class="nav-text">Backup</span>
                                </Link>
                            </li>
                            {/* <li></li>
                                <a href="payment-history.html">
                                    <img src="assets/images/payment%20History%20Icon.svg"/>
                                    <span class="nav-text">Payment History</span>
                                </a>
                            </li>
                            <li>
                                <a href="specialisms.html">
                                    <img src="assets/images/Specialization.svg"/>
                                    <span class="nav-text">Specialisms</span>
                                </a>
                            </li>
                            <li>
                                <a href="reports.html">
                                    <img src="assets/images/Reports.svg"/>
                                    <span class="nav-text">Reports</span>
                                </a>
                            </li>
                            <li>
                                <a href="reviews.html">
                                    <img src="assets/images/Reviews.svg"/>
                                    <span class="nav-text">Reviews</span>
                                </a>
                            </li>
                        
                            <li>
                                <a class="nav-link collapsed" data-bs-toggle="collapse" data-bs-target="#fghg" href="#">
                                    <img src="assets/images/wallet.svg"/>
                                    <span class="nav-text"> My Wallet</span> <i class="far fa-angle-down"></i>
                                </a>
                                <ul id="fghg" class="submenu collapse" data-bs-parent="#nav_accordion">
                                    <li><a class="nav-link" href="#">Add New </a></li>
                                    <li><a class="nav-link" href="#">Card List </a></li>
                                    <li><a class="nav-link" href="3">History </a></li>
                                </ul>
                            </li>
                            <li>
                                <a class="nav-link collapsed" data-bs-toggle="collapse" data-bs-target="#vbjh" href="#">
                                    <img src="assets/images/transaction.svg"/>
                                    <span class="nav-text"> Transaction</span> <i class="far fa-angle-down"></i>
                                </a>
                                <ul id="vbjh" class="submenu collapse" data-bs-parent="#nav_accordion">
                                    <li><a class="nav-link" href="#">Add New </a></li>
                                    <li><a class="nav-link" href="#">Card List </a></li>
                                    <li><a class="nav-link" href="3">History </a></li>
                                </ul>
                            </li>
                            <li>
                                <a class="nav-link collapsed" data-bs-toggle="collapse" data-bs-target="#ere" href="#">
                                    <img src="assets/images/stack.svg"/>
                                    <span class="nav-text"> Stake Now</span> <i class="far fa-angle-down"></i>
                                </a>
                                <ul id="ere" class="submenu collapse" data-bs-parent="#nav_accordion">
                                    <li><a class="nav-link" href="#">Add New </a></li>
                                    <li><a class="nav-link" href="#">Card List </a></li>
                                    <li><a class="nav-link" href="3">History </a></li>
                                </ul>
                            </li>
                            <li>
                                <a class="nav-link collapsed" data-bs-toggle="collapse" data-bs-target="#opo" href="#">
                                    <img src="assets/images/exchange.svg"/>
                                    <span class="nav-text"> Exchange</span> <i class="far fa-angle-down"></i>
                                </a>
                                <ul id="opo" class="submenu collapse" data-bs-parent="#nav_accordion">
                                    <li><a class="nav-link" href="#">Add New </a></li>
                                    <li><a class="nav-link" href="#">Card List </a></li>
                                    <li><a class="nav-link" href="3">History </a></li>
                                </ul>
                            </li>
                            <li> */}
                                {/* <a class="nav-link collapsed" data-bs-toggle="collapse" data-bs-target="#qwq" href="#">
                                    <img src="assets/images/settings.svg"/>
                                    <span class="nav-text"> Settings</span> <i class="far fa-angle-down"></i>
                                </a>
                                <ul id="qwq" class="submenu collapse" data-bs-parent="#nav_accordion">
                                    <li><a class="nav-link" href="#">Add New </a></li>
                                    <li><a class="nav-link" href="#">Card List </a></li>
                                    <li><a class="nav-link" href="3">History </a></li>
                                </ul> */}
                            </li>

                            
                        </ul>
                    </div>

                    <div class="user-dashboard-right">
                        <div class="header d-flex align-items-center">
                            <nav class="navbar navbar-expand top-bar">
                                <div class="nav-control">
                                    <div className={`hamburger ${hamburgerActive ? 'active' : ''}`} onClick={sidebarActivate} ><img src={menuIcon} class="img-fluid" /></div>
                                </div>
                            </nav>
                            <div class="page-head d-flex flex-wrap justify-content-between w-100">
                                <div className="left">
                                    {/* <div class="search">
                                      <input className="d-none" type="text" class="form-control" placeholder="Search..." />
                                    </div> */}
                                </div>
                                <div class="right">
                                    <ul class="common-links">
                                      <li>
                                          <div class="dropdown notify">
                                              <Link to="notifications"><i class="bi bi-bell"></i></Link>
                                       
                                          </div>
                                      </li> 
                                      


                                    <li className="dropdown profile-drop">
  <a href="#" className="user dropdown-toggle nav-link" data-bs-toggle="dropdown" data-bs-target="#dropdownMenuButton1" role="button" aria-expanded="false" aria-haspopup="true">
    <span>Imox <i class="bi bi-caret-down"></i></span>
  </a>  
  <ul className="dropdown-menu" id="dropdownMenuButton1">
    <li><button className="dropdown-item" onClick={logOut}>Logout</button></li> 
  </ul>
</li>
</ul>
                                    
                                </div>
                                
                                <div class="dropdown respmenu">
                    
                                  <button class="btn btn-secondary" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-three-dots-vertical" viewBox="0 0 16 16">
                                  <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"/>
                                </svg>
                                  </button>

                                  <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                    
                                    {/* <li><a class="dropdown-item" href="#">Notifications</a></li> */}
                                    <li><button className="dropdown-item" onClick={logOut}>Logout</button></li>

                                  </ul>
                                </div>
                                
                            </div>
                        </div>

                        <div class="clearfix"></div>

                        <div class="right-content">
                           <div class="page-head d-flex justify-content-between align-items-center flex-wrap">
                             {/* <h1>Dashboard</h1>  */}
                           </div>
                           <div class="container-fluid p-0">
                            <div class="row">
                              <div className='col-sm-12'>
                              {spinner ? <Loader /> : <></> } 
                              {/* {loactions.pathname === "/home" ? <Dashboard  /> : <></>} */}
                              <Outlet />

                              </div>
                            </div>
                           </div>  
                        </div>
                    </div>

                    <div class="clearfix"></div>
                </div>
            </div>
        </main>
    </div>
  )
}

export default Navbar
